/**
 * 用户操作日志服务
 * 记录用户在前台的各种操作
 */
const API_BASE = 'https://home.liukun.com:8443/Projects/AIMovie/api';
// 操作类型定义
export const LogActions = {
    // 页面访问
    PAGE_VIEW: '页面访问',
    // 用户相关
    USER_LOGIN: '用户登录',
    USER_LOGOUT: '用户退出',
    USER_REGISTER: '用户注册',
    // 项目相关
    PROJECT_CREATE: '创建项目',
    PROJECT_VIEW: '查看项目',
    PROJECT_EDIT: '编辑项目',
    PROJECT_DELETE: '删除项目',
    PROJECT_PUBLISH: '发布项目',
    // 剧本相关
    SCRIPT_EDIT: '编辑剧本',
    SCRIPT_SAVE: '保存剧本',
    SCRIPT_IMPORT: '导入剧本',
    // AI功能
    AI_GENERATE_IMAGE: 'AI生成图片',
    AI_GENERATE_VIDEO: 'AI生成视频',
    AI_GENERATE_VOICE: 'AI生成语音',
    AI_ANALYZE_SCRIPT: 'AI分析剧本',
    AI_AUTO_MATCH: 'AI智能匹配',
    // 分镜相关
    STORYBOARD_CREATE: '创建分镜',
    STORYBOARD_EDIT: '编辑分镜',
    STORYBOARD_GENERATE: '生成分镜',
    // 视频编辑
    VIDEO_EDIT: '视频编辑',
    VIDEO_PREVIEW: '视频预览',
    VIDEO_EXPORT: '视频导出',
    // 资源相关
    ASSET_UPLOAD: '上传资源',
    ASSET_DOWNLOAD: '下载资源',
    // 后台管理
    ADMIN_LOGIN: '管理员登录',
    ADMIN_DELETE: '管理员删除',
    ADMIN_BACKUP: '数据备份',
    ADMIN_RESTORE: '数据恢复',
    // 其他
    SEARCH: '搜索',
    SHARE: '分享',
    LIKE: '点赞',
    COMMENT: '评论',
};
/**
 * 记录用户操作日志（匿名用户也会记录）
 */
export async function logUserAction(data) {
    // 使用setTimeout确保不阻塞主线程
    setTimeout(async () => {
        try {
            // 优先使用前台token，其次使用管理员token
            const token = localStorage.getItem('token') || localStorage.getItem('adminToken');
            const response = await fetch(`${API_BASE}/logs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                },
                body: JSON.stringify({
                    action: data.action,
                    detail: data.detail || null,
                    pageUrl: data.pageUrl || window.location.href,
                    source: data.source || '前台'
                })
            });
            if (!response.ok) {
                console.warn('日志记录响应异常:', response.status);
            }
        }
        catch (error) {
            // 日志记录失败不影响用户操作，静默处理
            console.warn('日志记录失败:', error);
        }
    }, 0);
}
/**
 * 记录页面访问
 */
export function logPageView(pageName, source = '前台') {
    logUserAction({
        action: LogActions.PAGE_VIEW,
        detail: pageName,
        pageUrl: window.location.href,
        source
    });
}
/**
 * 记录后台管理操作
 */
export function logAdminAction(action, detail) {
    logUserAction({
        action,
        detail,
        source: '后台'
    });
}
/**
 * 创建日志记录器（用于特定模块）
 */
export function createLogger(moduleName, source = '前台') {
    return {
        log: (action, detail) => {
            logUserAction({
                action,
                detail: detail ? `[${moduleName}] ${detail}` : `[${moduleName}]`,
                source
            });
        },
        pageView: () => logPageView(moduleName, source)
    };
}
export default {
    logUserAction,
    logPageView,
    logAdminAction,
    createLogger,
    LogActions
};
